import Vue from "vue";
import Router from "vue-router";
import Layout from "@/views/layout/Layout";

Vue.use(Router);

export const constantRouterMap = [
  {
    path: "/redirect",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "/redirect/:path*",
        component: () => import("@/views/redirect/index"),
      },
    ],
  },
  {
    path: "/",
    component: Layout,
    redirect: "dashboard",
    children: [
      {
        path: "dashboard",
        component: () => import("@/views/dashboard/index"),
        name: "Dashboard",
        meta: {
          title: "dashboard",
          icon: "home",
          noCache: true,
          affix: true,
        },
      },
    ],
  },
  {
    path: "/login",
    component: () => import("@/views/login/index"),
    hidden: true,
  },
  {
    path: "/dataVisualization",
    component: Layout,
    meta: {
      title: "可视化平台",
      icon: "area",
    },
    children: [
      {
        path: "/dataStatistics",
        component: () => import("@/views/visualization/dataStatistics"),
        name: "数据可视化",
        meta: {
          title: "数据可视化",
        },
      },
      {
        path: "/mapStatistics",
        component: () => import("@/views/visualization/mapStatistics"),
        name: "地图可视化",
        meta: {
          title: "地图可视化",
        },
      },
      {
        path: "/communityDataStatistics",
        component: () => import("@/views/visualization/communityDataStatistics"),
        name: "社区可视化",
        meta: {
          title: "社区可视化",
        },
      },
      {
        path: "/glyMapStatistics",
        component: () => import("@/views/visualization/glyMapStatistics"),
        name: "高丽营地图可视化",
        meta: {
          title: "高丽营地图可视化",
        },
      },
      
    ],
  },
];
export default new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap,
});
//后台控制的带权限的路由
export const asyncRouterMap = [
  {
    path: "/recyclingMachineList",
    name: "智能回收机管理",
    component: Layout,
    meta: {
      title: "智能回收机管理",
      icon: "data",
    },
    children: [
      {
        path: "/recyclingMachineList",
        component: () => import("@/views/recyclingMachine/recyclingMachineList"),
        name: "智能回收机",
        meta: {
          title: "智能回收机",
        },
     },
      {
        path: "/recyclingMachineMapList",
        component: () => import("@/views/recyclingMachine/recyclingMachineMapList"),
        name: "RecyclingMachineMapList",
        meta: {
          title: "智能回收机gps",
        },
     },
      {
        path: "/recyclingMachineDetail/:id",
        component: () => import("@/views/recyclingMachine/recyclingMachineDetail"),
        name: "智能回收机详情",
        hidden: true,
        meta: {
          title: "智能回收机详情",
        },
     },
     
    ]
    
  },
  {
    path: "/recyclingMachineOrder",
    name: "回收机订单管理",
    component: Layout,
    meta: {
      title: "智能回收机管理",
      icon: "data",
    },
    children: [
      {
        path: "/recyclingMachineOrderList",
        component: () => import("@/views/recyclingMachineOrder/orderList"),
        name: "智能回收机订单",
        meta: {
          title: "智能回收机订单",
        },
     },
      {
        path: "/orderListDetail/:id",
        component: () => import("@/views/recyclingMachineOrder/orderDetail"),
        name: "RecycleOrderDetail",
        hidden: true,
        meta: {
          title: "智能回收机订单详情",
        },
     },
    
    ]
    
  },
  {
    path: "/traceabilityCode",
    component: Layout,
    meta: {
      title: "溯源码出袋机管理",
      icon: "area",
    },
    children: [
      {
        path: "/list",
        component: () => import("@/views/traceabilityCode/list"),
        name: "溯源码出袋机列表",
        meta: {
          title: "溯源码出袋机列表",
        },
      },
      {
        path: "/recordList",
        component: () => import("@/views/traceabilityCode/recordList"),
        name: "溯源码出袋机记录列表",
        meta: {
          title: "溯源码出袋机记录列表",
        },
      }
    ],
  },
  {
    path: "/selfServiceStations",
    component: Layout,
    meta: {
      title: "自助驿站开门记录",
      icon: "area",
    },
    children: [
      {
        path: "/selfServiceStations",
        component: () => import("@/views/selfServiceStations/index"),
        name: "自助驿站开门记录",
        meta: {
          title: "自助驿站开门记录",
        },
      }
    ],
  },
  // 数据统计
  {
    path: "/data",
    component: Layout,
    meta: {
      title: "数据管理",
      icon: "data",
    },
    children: [
      {
        path: "userStatistics",
        component: () => import("@/views/data/userStatistics"),
        name: "用户统计",
        meta: {
          title: "用户统计",
        },
      },
      {
        path: "userList",
        component: () => import("@/views/data/userList"),
        name: "用户列表",
        meta: {
          title: "用户列表",
        },
      },
      {
        path: "userAmountList",
        component: () => import("@/views/data/userAmount"),
        name: "可提现用户列表",
        meta: {
          title: "可提现用户列表",
        },
      },
      {
        path: "userAmountListRecord",
        component: () => import("@/views/data/userAmountList"),
        name: "用户钱包记录列表",
        meta: {
          title: "用户钱包记录列表",
        },
      },
      {
        path: "frontendRoleList",
        component: () => import("@/views/data/frontendRoleList"),
        name: "前端角色",
        meta: {
          title: "前端角色",
        },
      },
      {
        path: "frontendRoleUserList",
        component: () => import("@/views/data/frontendRoleUserList"),
        name: "前端角色用户",
        meta: {
          title: "前端角色用户",
        },
      },
      {
        path: "/userRecycleList",
        component: () => import("@/views/data/userRecycleList"),
        hidden: true,
        name: "用户订单记录",
        meta: {
          title: "用户订单记录",
        },
      },
      {
        path: "nguidanceList",
        component: () => import("@/views/data/nguidanceList"),
        name: "指导员列表",
        meta: {
          title: "指导员列表",
        },
      },
      {
        path: "recyclerList",
        component: () => import("@/views/data/recyclerList"),
        name: "回收员列表",
        meta: {
          title: "回收员列表",
        },
      },


      {
        path: "TradeList",
        component: () => import("@/views/data/TradeList"),
        name: "交易列表",
        meta: {
          title: "交易列表",
        },
      },
      {
        path: "walimanage",
        component: () => import("@/views/data/walimanage"),
        name: "回收列表",
        meta: {
          title: "回收列表",
        },
      },
      {
        path: "ReclaimEventManage",
        component: () => import("@/views/data/ReclaimEventManage"),
        name: "回收事件管理",
        meta: {
          title: "回收事件管理",
        },
      },
      {
        path: "traceabilityCodingList",
        component: () => import("@/views/data/traceabilityCodingList"),
        name: "溯源码列表",
        meta: {
          title: "溯源码列表",
        },
      },
      {
        path: "recycleSortAudit",
        component: () => import("@/views/data/recycleSortAudit"),
        name: "可回收物扣减审批",
        meta: {
          title: "可回收物扣减审批",
        },
      },
    ],
  },
  {
    path: "/order",
    component: Layout,
    meta: {
      title: "订单数据",
      icon: "order",
    },
    children: [
      {
        path: "signedAmount",
        component: () => import("@/views/order/signedAmount"),
        name: "签收量",
        meta: {
          title: "签收量",
        },
      },
      {
        path: "orderAmount",
        component: () => import("@/views/order/orderAmount"),
        name: "预约量",
        meta: {
          title: "预约量",
        },
      },
    ],
  },

  {
    path: "/sign",
    component: Layout,
    meta: {
      title: "签收管理",
      icon: "sign",
    },
    children: [
      {
        path: "ordering",
        component: () => import("@/views/sign/ordering"),
        name: "预约中",
        meta: {
          title: "预约中",
        },
      },
      {
        path: "recyclable",
        component: () => import("@/views/sign/recyclable"),
        name: "可回收",
        meta: {
          title: "可回收",
        },
      },
      {
        path: "comment",
        component: () => import("@/views/sign/comment"),
        name: "评价列表",
        meta: {
          title: "评价列表",
        },
      },
    ],
  },
  {
    path: "/carbonEnergyManage",
    component: Layout,
    meta: {
      title: "碳能量管理",
      icon: "sign",
    },
    children: [
      {
        path: "/userceManage",
        component: () => import("@/views/carbonEnergyManage/carbonEnergyManage"),
        name: "用户碳能量管理",
        meta: {
          title: "用户碳能量管理",
        },
      },
      {
        path: "/carbonEnergyDetail",
        component: () => import("@/views/carbonEnergyManage/carbonEnergyDetail"),
        name: "碳能量记录",
        meta: {
          title: "碳能量记录",
        },
      },
    ],
  },
  {
    path: "/convenienceStore",
    component: Layout,
    meta: {
      title: "便利店管理",
      icon: "sign",
    },
    children: [
      {
        path: "/shopList",
        component: () => import("@/views/convenienceStore/shopList"),
        name: "便利店列表",
        meta: {
          title: "便利店列表",
        },
      },
      {
        path: "/shopWalletList",
        component: () => import("@/views/convenienceStore/shopWalletList"),
        name: "便利店钱包列表",
        meta: {
          title: "便利店钱包列表",
        },
      },
      {
        path: "/shopDrawMoneyList",
        component: () => import("@/views/convenienceStore/shopDrawMoneyList"),
        name: "便利店提现列表",
        meta: {
          title: "便利店提现列表",
        },
      },
      {
        path: "/cashierList",
        component: () => import("@/views/convenienceStore/cashierList"),
        name: "收银员列表",
        meta: {
          title: "收银员列表",
        },
      },
      {
        path: "/cashierOrders",
        component: () => import("@/views/convenienceStore/cashierOrders"),
        name: "收银员订单列表",
        meta: {
          title: "收银员订单列表",
        },
      },
      {
        path: "offlineTradeList",
        component: () => import("@/views/data/offlineTradeList"),
        name: "线下交易列表",
        meta: {
          title: "线下交易列表",
        },
      },
    ],
  },

  {
    path: "/bulky",
    component: Layout,
    meta: {
      title: "大件管理",
      icon: "sign",
    },
    children: [
      {
        path: "/bulkyOrder",
        component: () => import("@/views/bulkyManage/bulkyOrder"),
        name: "大件订单管理",
        meta: {
          title: "大件订单管理",
        },
      },
    ],
  },
  {
    path: "/recorderManage",
    component: Layout,
    meta: {
      title: "记录仪管理",
      icon: "sign",
    },
    children: [
      {
        path: "/recorderList",
        component: () => import("@/views/recorderManage/recorderList"),
        name: "记录仪列表",
        meta: {
          title: "记录仪列表",
        },
      },
      {
        path: "/recorderMap",
        component: () => import("@/views/recorderManage/recorderMap"),
        name: "记录仪定位",
        meta: {
          title: "记录仪定位",
        },
      },
    ],
  },
  {
    path: "/workingManage",
    component: Layout,
    meta: {
      title: "gps管理",
      icon: "dashboard",
    },
    children: [
      {
        path: "/workingMap",
        component: () => import("@/views/workingManage/workingMap"),
        name: "定位监控",
        meta: {
          title: "定位监控",
        },
      },
      {
        path: "/deviceList",
        component: () => import("@/views/workingManage/deviceList"),
        name: "设备列表",
        meta: {
          title: "设备列表",
        },
      },
      {
        path: "/clockInList",
        component: () => import("@/views/workingManage/clockInList"),
        name: "打卡列表",
        meta: {
          title: "打卡列表",
        },
      },
      {
        path: "/warningList",
        component: () => import("@/views/workingManage/warningList"),
        name: "告警列表",
        meta: {
          title: "告警列表",
        },
      },
      {
        path: "/journeyList",
        component: () => import("@/views/workingManage/journeyList"),
        name: "行程列表",
        meta: {
          title: "行程列表",
        },
      },
      {
        path: "/remainList",
        component: () => import("@/views/workingManage/remainList"),
        name: "停留列表",
        meta: {
          title: "停留列表",
        },
      },
      {
        path: "/positioningTrack",
        component: () => import("@/views/workingManage/positioningTrack"),
        hidden: true,
        // name: "定位轨迹",
        // meta: {
        //   title: "定位轨迹",
        // },
      },
    ],
  },
  {
    path: "/patrolInspection",
    component: Layout,
    meta: {
      title: "巡检管理",
      icon: "inspector",
    },
    children: [
      {
        path: "garbageStation",
        // component: () => import("@/views/workRepork/workRepork"),
        component: () => import("@/views/garbage/garbage"),
        name: "桶站列表",
        meta: {
          title: "桶站列表",
        },
      },
      {
        path: "garbageStationSorter",
        component: () => import("@/views/garbage/garbageStationSorter"),
        name: "指导员列表",
        meta: {
          title: "指导员列表",
        },
      },
      {
        path: "/gssRelationMange",
        component: () => import("@/views/garbage/gssRelationMange"),
        name: "桶站关系列表",
        meta: {
          title: "桶站关系列表",
        },
      },
      {
        path: "wlInspectionUser",
        component: () => import("@/views/garbage/wlInspectionUser"),
        name: "巡检员列表",
        meta: {
          title: "巡检员列表",
        },
      },
      {
        path: "wlInspectionRecord",
        component: () => import("@/views/garbage/inspectionRecord"),
        name: "巡检记录列表",
        meta: {
          title: "巡检记录列表",
        },
      },
      {
        path: "/garbageStationSorterStatistics",
        component: () =>
          import("@/views/garbage/garbageStationSorterStatistics"),
        name: "指导员报表",
        meta: {
          title: "指导员报表",
        },
      },
      {
        path: "/inspectionUserStatistics",
        component: () => import("@/views/garbage/inspectionUserStatistics"),
        name: "巡检员报表",
        meta: {
          title: "巡检员报表",
        },
      },
      {
        path: "/communityStatistics",
        component: () => import("@/views/garbage/communityStatistics"),
        name: "工作社区报表",
        meta: {
          title: "工作社区报表",
        },
      },
      {
        path: "streetStatistics",
        component: () => import("@/views/garbage/streetStatistics"),
        name: "街道报表",
        meta: {
          title: "街道报表",
        },
      },
      {
        path: "/wlDailyWorkReport/dayList",
        component: () => import("@/views/garbage/dayList"),
        name: "工作日报",
        meta: {
          title: "工作日报",
        },
      },
      {
        path: "/dailyInspectionMange",
        component: () => import("@/views/garbage/dailyInspectionMange"),
        name: "日常巡检记录列表",
        meta: {
          title: "日常巡检记录列表",
        },
      },
      {
        path: "/employeeIncidentManagement",
        component: () => import("@/views/garbage/employeeIncidentManagement"),
        name: "员工事件管理",
        meta: {
          title: "员工事件管理",
        },
      },
      {
        path: "/ledgerList",
        component: () => import("@/views/garbage/ledgerList"),
        name: "台账列表",
        meta: {
          title: "台账列表",
        },
      },
    ],
  },
  {
    path: "/mall",
    component: Layout,
    meta: {
      title: "商城管理",
      icon: "mall",
    },
    children: [
      {
        path: "mallProduct",
        component: () => import("@/views/mall/mallProduct"),
        name: "商品管理",
        meta: {
          title: "商品管理",
        },
      },
      {
        path: "mallClassify",
        component: () => import("@/views/mall/mallClassify"),
        name: "商品分类管理",
        meta: {
          title: "商品分类管理",
        },
      },
      {
        path: "mallOrder",
        component: () => import("@/views/mall/mallOrder"),
        name: "商城订单管理",
        meta: {
          title: "商城订单管理",
        },
      },
      {
        path: "/provinceManage",
        component: () => import("@/views/mall/provinceManage"),
        name: "省市县地址管理",
        meta: {
          title: "省市县地址管理",
        },
      },
    ],
  },
  {
    path: "/cleanManage",
    component: Layout,
    meta: {
      title: "清运管理",
      icon: "clean",
    },
    children: [
      {
        path: "cleanPoint",
        component: () => import("@/views/cleanManage/cleanPoint"),
        name: "清运点位",
        meta: {
          title: "清运点位",
        },
      },
      {
        path: "cleanRecord",
        component: () => import("@/views/cleanManage/cleanRecord"),
        name: "清运记录",
        meta: {
          title: "清运记录",
        },
      },
    ],
  },
  {
    path: "/contractManage",
    component: Layout,
    meta: {
      title: "合同管理",
      icon: "sign",
    },
    children: [
      {
        path: "/entryContractManage",
        component: () =>
          import("@/views/entryContractManage/entryContractManage"),
        name: "入账合同管理",
        meta: {
          title: "入账合同管理",
        },
      },
    ],
  },
  {
    path: "/finance",
    component: Layout,
    meta: {
      title: "财务",
      icon: "sign",
    },
    children: [
      {
        path: "/financialStatement",
        component: () => import("@/views/finance/financialStatement"),
        name: "对账单列表",
        meta: {
          title: "对账单列表",
        },
      },
      {
        path: "/realTimeAccount",
        component: () => import("@/views/finance/realTimeAccount"),
        name: "实时对账单",
        meta: {
          title: "实时对账单",
        },
      },
    ],
  },
  {
    path: "/officialAccountManage",
    component: Layout,
    meta: {
      title: "公众号管理",
      icon: "sign",
    },
    children: [
      {
        path: "/officialAccountList",
        component: () => import("@/views/officialAccountManage/officialAccountList"),
        name: "公众号用户列表",
        meta: {
          title: "公众号用户列表",
        },
      },
    ],
  },
  {
    path: "/system",
    component: Layout,
    meta: {
      title: "系统管理",
      icon: "system",
    },
    children: [
      {
        path: "userList",
        component: () => import("@/views/system/userList"),
        name: "系统用户",
        meta: {
          title: "系统用户",
        },
      },
      {
        path: "roleList",
        component: () => import("@/views/system/roleList"),
        name: "角色管理",
        meta: {
          title: "角色管理",
        },
      },
      {
        path: "sysDataDict",
        component: () => import("@/views/system/sysDataDictList"),
        name: "数据字典管理",
        meta: {
          title: "数据字典管理",
        },
      },
      {
        path: "system",
        component: () => import("@/views/system/menuList"),
        name: "菜单管理",
        meta: {
          title: "菜单管理",
        },
      },
      {
        path: "/informList",
        component: () => import("@/views/convenienceStore/informList"),
        name: "通知管理",
        meta: {
          title: "通知管理",
        },
      },
      {
        path: "/waliClassroomManage",
        component: () => import("@/views/waliClassroomManage/waliClassroomList"),
        name: "瓦力课堂管理",
        meta: {
          title: "瓦力课堂管理",
        },
      },
    ],
  },
  {
    path: "/area",
    component: Layout,
    meta: {
      title: "区域管理",
      icon: "area",
    },
    children: [
      {
        path: "community",
        component: () => import("@/views/area/community"),
        name: "社区管理",
        meta: {
          title: "社区管理",
        },
      },
      {
        path: "street",
        component: () => import("@/views/area/street"),
        name: "街道管理",
        meta: {
          title: "街道管理",
        },
      },
    ],
  },
  {
    path: "/404",
    component: () => import("@/views/errorPage/404"),
    hidden: true,
  },
  {
    path: "/401",
    component: () => import("@/views/errorPage/401"),
    hidden: true,
  },

  { path: "*", redirect: "/404", hidden: true },
];
